module.exports = __webpack_public_path__ + "static/media/jcb.cf482d84.png";